import { makePalette } from '@saas/lib/shared-utils'

export const palette = makePalette({
    blue: {
        100: '#F7FEFE',
        500: '#24C3CF',
    },
    success: {
        400: '#52CB94',
    },
    error: {
        100: '#FFF5F7',
        400: '#FB355D',
        500: '#e61942',
    },
    lightGrey: {
        500: '#EBEEF5',
        520: '#F0EEF9',
        550: '#DDE1EC',
        600: '#dde3e3',
    },
    surface: {
        100: '#ffffff',
    },
    typography: {
        100: '#FAFAFA',
        900: '#313336',
    },
    neutral: {
        100: '#F5F4FB',
        150: '#FDFDFE',
        200: '#FBFBFE',
        300: '#EDEDED',
        400: '#B6C0CF',
        500: '#E5E9F2',
        600: '#A5A5A5',
        700: '#4E5054',
        800: '#616F86',
    },
    transmission: {
        200: '#F1F1FE',
        300: '#D0D4FA',
        400: '#9496CC',
        600: '#575BAF',
        700: '#2E0DA6',
    },
    warning: {
        50: '#FFFAF5',
        100: '#FFF3E5',
        600: '#FB7D08',
    },
})
